import { Component, OnInit } from '@angular/core';
import {
  Platform,
  ModalController,
  AlertController,
  ActionSheetController,
  ToastController,
  ViewWillEnter,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonButton,
  IonIcon,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonBadge,
  IonContent,
  IonList,
  IonSearchbar,
  IonCard,
  IonItem,
  IonThumbnail,
  IonSelect,
  IonSelectOption,
} from '@ionic/angular/standalone';
//import { Http, Headers } from '@angular/http';
//import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { LoadingController } from '@ionic/angular/standalone';
//import * as appconfig from '../../appconfig'
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { GroupServices } from '../../providers/group-services';
import { ClubAddPage } from './club-add/club-add.page';
import { ClubMembersPage } from './club-members/club-members.page';
import { EmailServices } from '../../providers/email-services';
import { AgentsService } from '../../providers/crm-agent-provider';
import { LanguageProvider } from '../../providers/language';
import { GoogleAnalyticsService } from 'src/app/providers/google-analytics.service';
import { Globalization } from '@awesome-cordova-plugins/globalization/ngx';
import { Router, ActivatedRoute } from '@angular/router';

import { GlobalDataService } from 'src/app/providers/global-data.service';
import { AdsServicesService } from '../../providers/ads-services.service';
import { common } from 'src/environments/environment';
import { addIcons } from 'ionicons';
import { addCircle, checkmarkCircle, settings, alert } from 'ionicons/icons';
import { FormsModule } from '@angular/forms';
import { MenuTriggerComponent } from '../../components/side-nav/menu-trigger.component';
import { NgIf, NgFor, CommonModule } from '@angular/common';

@Component({
  selector: 'app-clubs',
  templateUrl: './clubs.page.html',
  styleUrls: ['./clubs.page.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    MenuTriggerComponent,
    IonTitle,
    IonButton,
    IonIcon,
    IonSegment,
    FormsModule,
    IonSegmentButton,
    IonLabel,
    NgIf,
    IonBadge,
    IonContent,
    IonList,
    IonSearchbar,
    NgFor,
    IonCard,
    IonItem,
    IonThumbnail,
    IonSelect,
    IonSelectOption,
    TranslatePipe,
    CommonModule,
  ],
})
export class ClubsPage implements ViewWillEnter {
  agent: any;
  agentId: number;
  agentEmail: string;
  groupView: string = 'my';
  myGroupsList: any;
  myGroupsStoreList: any;
  publicGroupsList: any;
  pubGroupsStoreList: any;
  privateGroupsList: any;
  priGroupsStoreList: any;
  allGroupsList: any;
  publicGroupType = 'P';
  closedGroupType = 'C';
  secretGroupType = 'S';
  groupMembers: any;
  searchValue: string;
  totalPendinActionsMy: number;
  totalPendinActionsPending: number;
  groupTypeSelect: string;
  country: string;
  collectionCountries: any;
  selectedCountry: string = 'All';
  selectedCountryPub: string = 'All';

  deviceLang: any;
  deviceLocale: any;
  deviceCountry: string;
  localesLoaded: boolean = false;

  priList: any;
  priListC: any;
  priListA: any;
  pubList: any;
  pubListC: any;
  pubListA: any;

  constructor(
    public platform: Platform,
    public alertCtrl: AlertController,
    //              public http: Http,
    private actionSheetCtrl: ActionSheetController,
    public localStorage: Storage,
    public loading: LoadingController,
    public translate: TranslateService,
    private emailService: EmailServices,
    private agentsService: AgentsService,
    private groupServices: GroupServices,
    private langProvider: LanguageProvider,
    public modalCtrl: ModalController,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public gds: GlobalDataService,
    private ads: AdsServicesService,
    private gaService: GoogleAnalyticsService,
    private globalization: Globalization,
    private toastCtrl: ToastController
  ) {
    this.groupMembers = ClubMembersPage;
    void this.gaService.trackPageView('groups_list_page');

    addIcons({ addCircle, checkmarkCircle, settings, alert });
  }

  async ngOnInit() {
    // this.langProvider.getAppLocalesList().subscribe(
    //   (countries: any) => {
    //     this.collectionCountries = countries.resource;
    //   },
    //   (error) => {
    //     this.translate.use('en'.toLowerCase());
    //   }
    // );

    try {
      const countries: any = await this.langProvider.getAppLocalesList();
      this.collectionCountries = countries.resource;
    } catch (error) {
      this.translate.use('en'.toLowerCase());
    }

    this.gds.getAgent().subscribe((data) => {
      console.log('receiving agent data from GDS');
      console.log('agent is:');
      console.log(data);
      if (data !== undefined && data !== null) {
        this.agentId = data.AGENT_ID;
        this.agentEmail = data.EMAIL;
        this.agent = data;
        this.selectedCountry = data.country_cca2;
        this.selectedCountryPub = data.country_cca2;

        console.log('Getting Agent Information');
        this.groupTypeSelect = 'pub';
        this.loadMyGroups(this.agentId.toString());
        this.loadAllGroups(this.agentId.toString());
        if (this.activatedRoute.snapshot.paramMap.has('groupView')) {
          this.groupView =
            this.activatedRoute.snapshot.paramMap.get('groupView');
        }
      }
    });
  }

  ionViewWillEnter() {
    console.log('Getting Agent Information');
    this.groupTypeSelect = 'pub';
    if (this.activatedRoute.snapshot.paramMap.has('groupView')) {
      this.groupView = this.activatedRoute.snapshot.paramMap.get('groupView');
    }
    if (this.agentId !== undefined) {
      this.loadMyGroups(this.agentId.toString());
      this.loadAllGroups(this.agentId.toString());
    } else {
      setTimeout(() => {
        if (this.agentId !== undefined) {
          this.loadMyGroups(this.agentId.toString());
          this.loadAllGroups(this.agentId.toString());
        }
      }, 500);
    }
    //      this.ads.evtShowBannerAdd();
  }

  updatePendingActionsTotals(grpList) {
    console.log('in updatePendingActionsTotals');
    this.totalPendinActionsMy = 0;
    this.totalPendinActionsPending = 0;
    for (let item of grpList) {
      console.log('handling item');
      console.log(item);
      if (Number(item.numActionsPending) > 0) {
        if (item.STATUS === 1 || item.STATUS === 2) {
          console.log('incrementing totalPendinActionsPending');
          this.totalPendinActionsPending = this.totalPendinActionsPending + 1;
        }
        if (item.STATUS === 4 || item.STATUS === 3) {
          console.log('incrementing totalPendinActionsMy');
          this.totalPendinActionsMy =
            this.totalPendinActionsMy + Number(item.numActionsPending);
        }
      }
    }
  }

  //async loadMyGroups(agentId: string) {
  //
  //  let loader = await this.loading.create({
  //    spinner: 'bubbles'
  //  });
  //
  //  loader.present();
  //
  //  this.groupServices.getUserGroups(agentId)
  //    .subscribe( (myGroupsList: any)=> {this.myGroupsList = myGroupsList.resource;
  //                  console.log("MyGroupsList is:");
  //                  console.log(this.myGroupsList);
  //                  this.myGroupsList = this.myGroupsList.sort(function(a, b) {
  //                    var dif_A = a.max_message_in_group-a.last_read_message_in_group;
  //                    var dif_B = b.max_message_in_group-b.last_read_message_in_group;
  //                    console.log("Comparing " + dif_A + " - " + dif_B);
  //                    if ( dif_B > dif_A ) {console.log("returning 1"); return 1; }
  //                    if ( dif_B < dif_A ) {console.log("returning -1"); return -1; }
  //                    if ( b.numActionsPending < a.numActionsPending) {console.log("returning -1");return 1;}
  //                    return 0;
  //                  });
  //                  this.myGroupsStoreList = this.myGroupsList;
  //                  this.updatePendingActionsTotals(this.myGroupsList);
  //                  loader.dismiss()
  //                },
  //                (error)=> console.log(error))
  //}

  async loadMyGroups(agentId: string) {
    let loader = await this.loading.create({
      spinner: 'bubbles',
    });

    await loader.present(); // Show the loading spinner

    this.groupServices
      .getUserGroups(agentId)
      .then((response: any) => {
        this.myGroupsList = response.resource;
        console.log('MyGroupsList is:');
        console.log(this.myGroupsList);

        // Sorting logic
        this.myGroupsList = this.myGroupsList.sort((a, b) => {
          let dif_A = a.max_message_in_group - a.last_read_message_in_group;
          let dif_B = b.max_message_in_group - b.last_read_message_in_group;

          console.log(`Comparing ${dif_A} - ${dif_B}`);
          if (dif_B > dif_A) {
            console.log('returning 1');
            return 1;
          }
          if (dif_B < dif_A) {
            console.log('returning -1');
            return -1;
          }
          if (b.numActionsPending < a.numActionsPending) {
            console.log('returning -1');
            return 1;
          }
          return 0;
        });

        this.myGroupsStoreList = this.myGroupsList;
        this.updatePendingActionsTotals(this.myGroupsList);

        loader.dismiss();
      })
      .catch((error) => {
        console.log(error);
        loader.dismiss();
      });
  }

  //async loadAllGroups(agentId: string) {
  //  console.log("Entering loadAllGroups");
  //  let loader = await this.loading.create({
  //    spinner: 'bubbles'
  //  });
  //
  //  loader.present();
  //
  //  this.groupServices.getAgentNotInGroups(agentId)
  //    .subscribe( (allGroupsList: any)=> {this.allGroupsList = allGroupsList.resource;
  //                  console.log("allGroupsList is:");
  //                  console.log(this.allGroupsList);
  //
  //                  this.privateGroupsList = this.allGroupsList.filter((privateGroupsList) => {
  //                      return (privateGroupsList.group_type.indexOf('C') > -1);
  //                  })
  //                  this.priGroupsStoreList = this.privateGroupsList
  //                  this.onChangeCountryPri()
  //
  //                  this.publicGroupsList = this.allGroupsList.filter((publicGroupsList) => {
  //                      return (publicGroupsList.group_type.indexOf('P') > -1);
  //                  })
  //                  this.pubGroupsStoreList = this.publicGroupsList
  //                  this.onChangeCountryPub()
  //
  //                  loader.dismiss()
  //                },
  //                (error)=> console.log(error));
  //    console.log(this.priGroupsStoreList);
  //    console.log("Exiting loadAllGroups");
  //
  //}

  async loadAllGroups(agentId: string) {
    console.log('Entering loadAllGroups');
    let loader = await this.loading.create({
      spinner: 'bubbles',
    });

    await loader.present(); // Show the loader

    this.groupServices
      .getAgentNotInGroups(agentId)
      .then((response: any) => {
        this.allGroupsList = response.resource;
        console.log('allGroupsList is:');
        console.log(this.allGroupsList);

        // Filter private groups
        this.privateGroupsList = this.allGroupsList.filter(
          (privateGroupsList) => {
            return privateGroupsList.group_type.indexOf('C') > -1;
          }
        );
        this.priGroupsStoreList = this.privateGroupsList;
        this.onChangeCountryPri();

        // Filter public groups
        this.publicGroupsList = this.allGroupsList.filter(
          (publicGroupsList) => {
            return publicGroupsList.group_type.indexOf('P') > -1;
          }
        );
        this.pubGroupsStoreList = this.publicGroupsList;
        this.onChangeCountryPub();

        loader.dismiss();
      })
      .catch((error) => {
        console.log(error);
        loader.dismiss();
      });

    console.log('Exiting loadAllGroups');
  }

  showData() {
    if (this.groupView == 'all') {
      this.loadAllGroups(this.agentId.toString());
    } else {
      this.loadMyGroups(this.agentId.toString());
    }
  }

  navigateToClubMembers(club: any) {
    console.log('Pushing to group members page:');
    console.log({ group: club });
    this.gds.publishActiveClub({ group: club });
    this.router.navigate(['clubs', club.group_id, 'club-members']);
  }

  isUserInternal(email: string) {
    if (
      email == 'ExMEAnonymousAccount@exme.club' ||
      email == 'ExMEAnonymousAccount2@exme.club'
    )
      return true;
    return false;
  }

  async openModalAddGroup() {
    if (this.isUserInternal(this.agentEmail)) {
      await (
        await this.alertCtrl.create({
          header: this.translate.instant('ERROR_TITLE'),
          message: this.translate.instant(
            'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
          ),
          buttons: [this.translate.instant('CONTINUE')],
        })
      ).present();
      return;
    }
    console.log('a criar clube');
    console.log('Email is:' + this.agentEmail);
    let addGroupModal = await this.modalCtrl.create({ component: ClubAddPage });
    addGroupModal.present();
    const data = await addGroupModal.onDidDismiss();
    this.loadMyGroups(this.agentId.toString());
  }

  async joinPublicGroup(group) {
    if (this.isUserInternal(this.agentEmail)) {
      const alt = await this.alertCtrl.create({
        header: this.translate.instant('ERROR_TITLE'),
        message: this.translate.instant(
          'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
        ),
        buttons: [this.translate.instant('CONTINUE')],
      });
      alt.present();
      return;
    }

    let alert = await this.alertCtrl.create({
      header: group.Group_name,
      subHeader: this.translate.instant('JOIN_PUBLIC_GROUP_MSG'),
      buttons: [
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: (data) => {
            this.addAgentToGroup(
              group.group_id,
              this.agentId,
              group.Group_name,
              group.group_description,
              group.manager_email,
              'public'
            );
            this.ionViewWillEnter();
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  async joinPrivateGroup(group) {
    if (this.isUserInternal(this.agentEmail)) {
      (
        await this.alertCtrl.create({
          header: this.translate.instant('ERROR_TITLE'),
          message: this.translate.instant(
            'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
          ),
          buttons: [this.translate.instant('CONTINUE')],
        })
      ).present();
      return;
    }

    let alert = await this.alertCtrl.create({
      header: group.Group_name,
      subHeader: this.translate.instant('JOIN_PRIVATE_GROUP_MSG'),
      buttons: [
        {
          text: this.translate.instant('ADD_ENTRY_CANCEL'),
          role: 'cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: (data) => {
            this.ionViewWillEnter();
            this.addAgentToGroup(
              group.group_id,
              this.agentId,
              group.Group_name,
              group.group_description,
              group.manager_email,
              'private'
            );
          },
        },
      ],
      cssClass: 'alert-buttons',
    });
    alert.present();
  }

  async addAgentToGroup(
    groupId,
    agentId,
    groupName,
    groupDescription,
    manager_email,
    groupType
  ) {
    console.log('Adding agent to group');
    let toastMessage = this.translate.instant('EMAIL_SEND_TOAST_MESSAGE');
    if (groupType === 'public') {
      toastMessage = 'Parabéns, já pertences ao clube ' + groupName;
    }

    if (this.isUserInternal(this.agentEmail)) {
      await (
        await this.alertCtrl.create({
          header: this.translate.instant('ERROR_TITLE'),
          message: this.translate.instant(
            'INVALID_OPERATION_FOR_INTERNAL_USERS_ERROR'
          ),
          buttons: [this.translate.instant('CONTINUE')],
        })
      ).present();
      return;
    }
    //this.groupServices.callProcToAddAgentToGroup(groupId, agentId)
    //  .subscribe ( async () => {
    //    if (this.platform.is('cordova')) {
    //      this.ga.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 1).then(() => {});
    //    }
    //    this.ads.evtShowInterstitialAdd('G');
    //    if (groupType === 'private') {
    //      //this.sendEntryRequestMail(manager_email, this.agentEmail, groupName);
    //      this.groupServices.getGroupAdmins(groupId).subscribe(
    //        (adminList: any) => {
    //          console.log("Got List of Administrators");
    //          console.log(adminList.resource);
    //          for (let admin of adminList.resource) {
    //            console.log("Processing Administrator:")
    //            console.log(admin);
    //            this.sendEntryRequestMail(admin.CRM_AGENT_by_AGENT_ID.EMAIL, this.agent.FIRST_NAME + " " + this.agent.LAST_NAME, groupName);
    //          }
    //        }
    //      )
    //    }
    //    let toast = await this.toastCtrl.create({
    //      message: toastMessage,
    //      duration: 3000,
    //      position: 'bottom'
    //    });
    //    toast.present();
    //    this.ionViewWillEnter();
    //  }, (err) => {
    //    if (this.platform.is('cordova')) {
    //      this.ga.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 0).then(() => {});
    //    }
    //  }
    //  )

    try {
      await this.groupServices.callProcToAddAgentToGroup(groupId, agentId);

      void this.gaService.trackEvent('groups_list_page', 'add_agent_to_group', 'success', 1);

      this.ads.evtShowInterstitialAdd('G');

      if (groupType === 'private') {
        try {
          const adminList: any = await this.groupServices.getGroupAdmins(
            groupId
          );
          console.log('Got List of Administrators:', adminList.resource);

          for (let admin of adminList.resource) {
            console.log('Processing Administrator:', admin);
            this.sendEntryRequestMail(
              admin.CRM_AGENT_by_AGENT_ID.EMAIL,
              this.agent.FIRST_NAME + ' ' + this.agent.LAST_NAME,
              groupName
            );
          }
        } catch (error) {
          console.error('Error retrieving group admins:', error);
        }
      }

      let toast = await this.toastCtrl.create({
        message: toastMessage,
        duration: 3000,
        position: 'bottom',
      });
      toast.present();

      this.ionViewWillEnter();
    } catch (err) {
      console.error('Error adding agent to group:', err);

      void this.gaService.trackEvent('groups_list_page', 'add_agent_to_group', 'failure', 0);
    }
  }

  sendEntryRequestMail(
    targetEmail: string,
    senderName: string,
    groupName: string
  ) {
    let emailBody = {
      template: this.translate.instant('GROUP_MAIL_TEMPLATE'),
      subject: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_SUBJECT'),
      to: [
        {
          name: targetEmail,
          email: targetEmail,
        },
      ],
      contexto: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_CONTEXT'),
      informacao: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_INFORMATION'),
      sender: senderName,
      mensagem: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_MESSAGE'),
      accao: this.translate.instant('GROUP_PRIV_REQUEST_MAIL_ACTION'),
    };
    this.agentsService
      .agentAllowsMails(targetEmail, this.agentId.toString())
      .subscribe(async (allowMail) => {
        if (allowMail == true) {
          // this.emailService
          //   .sendEmail(emailBody)
          //   .subscribe((error) => console.log(error));

          try {
            await this.emailService.sendEmail(emailBody);
          } catch (error) {
            console.log(error);
          }
          console.log(emailBody);
          console.log('mail enviado');
        } else {
          let toast = await this.toastCtrl.create({
            message: this.translate.instant(
              'EMAIL_NOT_SENT_DISALLOWED_BY_USER'
            ),
            duration: 3000,
            position: 'bottom',
          });
          toast.present();
        }
      });
  }

  onInputMy(event: any) {
    let val = event.target.value;

    if (val && val.trim() != '') {
      this.myGroupsList = this.myGroupsStoreList.filter((myGroupsList) => {
        return (
          myGroupsList.Group_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    } else {
      this.myGroupsList = this.myGroupsStoreList;
    }
  }

  actionSheet: any;

  async processClickPrivate(group: any) {
    this.actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('MORE_OPTIONS'),
      buttons: [
        {
          text: this.translate.instant('CHECK_CLUB'),
          handler: () => {
            console.log('Going to Group:');
            console.log(group);
            this.navigateToClubMembers(group);
            //            this.router.navigate(['/clubs/club-members',group]);
            //            let grpMembers = GroupMembersPage;
            //            this.navCtrl.push(grpMembers , group);
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: () => {
            this.joinPrivateGroup(group);
          },
        },
      ],
    });

    await this.actionSheet.present();
  }

  async processClick(group: any) {
    this.actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('MORE_OPTIONS'),
      buttons: [
        {
          text: this.translate.instant('CHECK_CLUB'),
          handler: () => {
            //            let grpMembers = GroupMembersPage;
            //            this.navCtrl.push(grpMembers , group);
            console.log('Going to Group:');
            console.log(group);
            this.navigateToClubMembers(group);
            //          this.router.navigate(['/clubs/club-members',group]);
          },
        },
        {
          text: this.translate.instant('JOIN_GROUP'),
          handler: () => {
            this.joinPublicGroup(group);
          },
        },
      ],
    });

    await this.actionSheet.present();
  }

  onChangeCountryPub() {
    if (this.selectedCountryPub == 'All') {
      this.pubList = this.publicGroupsList;
    } else {
      this.pubListC = this.publicGroupsList.filter((filteredPub) => {
        return (
          filteredPub.country
            .toLowerCase()
            .indexOf(this.selectedCountryPub.toLowerCase()) > -1
        );
      });
      this.pubListA = this.publicGroupsList.filter((filteredPub) => {
        return filteredPub.country.indexOf('All') > -1;
      });
      this.pubList = this.pubListC.concat(this.pubListA);
    }
  }

  onChangeCountryPri() {
    if (this.selectedCountry == 'All') {
      this.priList = this.privateGroupsList;
    } else {
      this.priListC = this.privateGroupsList.filter((filteredPri) => {
        return (
          filteredPri.country
            .toLowerCase()
            .indexOf(this.selectedCountry.toLowerCase()) > -1
        );
      });
      this.priListA = this.privateGroupsList.filter((filteredPri) => {
        return filteredPri.country.indexOf('All') > -1;
      });
      this.priList = this.priListC.concat(this.priListA);
    }
    console.log('priList is:', this.priList);
  }

  onInputPri(event: any) {
    let val = event.target.value;

    if (val && val.trim() != '') {
      this.privateGroupsList = this.priGroupsStoreList.filter(
        (privateGroupsList) => {
          console.log(privateGroupsList);
          return (
            privateGroupsList.Group_name.toLowerCase().indexOf(
              val.toLowerCase()
            ) > -1
          );
        }
      );
    } else {
      this.privateGroupsList = this.priGroupsStoreList;
    }
    this.onChangeCountryPri();
  }

  onInputPub(event: any) {
    let val = event.target.value;

    if (val && val.trim() != '') {
      this.publicGroupsList = this.pubGroupsStoreList.filter(
        (publicGroupsList) => {
          console.log(publicGroupsList);
          return (
            publicGroupsList.Group_name.toLowerCase().indexOf(
              val.toLowerCase()
            ) > -1
          );
        }
      );
    } else {
      this.publicGroupsList = this.pubGroupsStoreList;
    }
    this.onChangeCountryPub();
  }
}
